import UpdateAddUser from './UpdateAddUser.container';

export default UpdateAddUser;
